import _ from 'lodash'
import positionService from '@/API/positionService'
import {
  SET_POSITION_LIST,
  SET_SELECTED_POSITION,
  SET_SELECTED_POSITION_NAME,
  SET_ABILITY_ADD_DRIVER,
  SET_ABILITY_EDIT_DRIVER,
  SET_ABILITY_DRIVER_SERVICE,
  SET_ABILITY_DRIVER_MONITOR,
  SET_ABILITY_DRIVER_TRAJECTORY,
  SET_ABILITY_DRIVER_MESSAGE,
  SET_ABILITY_TRANSACTION,
  SET_ABILITY_TRANSACTION_STATISTICS,
  SET_ABILITY_CUSTOMER,
  SET_ABILITY_STORE,
  SET_ABILITY_LANDMARK,
  SET_ABILITY_RESERVATION,
  SET_ABILITY_DISPATCH_AREA,
  SET_ABILITY_SCHEDULED_AREA,
  SET_ABILITY_SCHEDULED_BOARD,
  SET_ABILITY_MOBILE_PAYMENT,
  SET_ABILITY_USER_MANAGEMENT,
  SET_ABILITY_USER_BEHAVIOR,
  SET_ABILITY_POSITION_MANAGEMENT,
  SET_ABILITY_TRANSACTION_RECORD,
  SET_ABILITY_CALL_CAR,
  SET_ABILITY_SAVE_HAIL_BILL,
  SET_ABILITY_SAVE_RESERVATION,
  SET_ABILITY_ANNOUNCEMENT,
  SET_ABILITY_USER_DELETION,
} from './mutation-types'
import defaultFormatPositionInfo from '@/defaultFormat/defaultFormatPosiitionInfo'

export default {
  fetchPositionList({ commit }) {
    return positionService
      .getPositionList()
      .then((res) => res.result)
      .then((result) => result.sort((a, b) => a.positionId - b.positionId))
      .then((result) => {
        commit(SET_POSITION_LIST, _.cloneDeep(result))
        commit(SET_SELECTED_POSITION, _.cloneDeep(result[0]))
      })
      .catch((err) => {
        console.error(err)
      })
  },
  postNewPosition({ state }) {
    const { selectedPosition } = state
    delete selectedPosition.positionId
    return positionService.addNewPosition(selectedPosition)
  },
  updatePositionAbility({ state }, id) {
    const { selectedPosition } = state
    delete selectedPosition.positionId
    return positionService.updatePosition(id, selectedPosition)
  },
  setSelectedPositionById({ commit, getters }, id) {
    const selectedPosition =
      id === -1
        ? _.cloneDeep(defaultFormatPositionInfo)
        : _.cloneDeep(
            getters.getPositionList
              .filter((position) => position.positionId === id)
              .pop(),
          )
    commit(SET_SELECTED_POSITION, selectedPosition)
  },
  setSeletedPositionName({ commit }, name) {
    commit(SET_SELECTED_POSITION_NAME, name)
  },
  setAbilityAddDriver({ commit }, ability) {
    commit(SET_ABILITY_ADD_DRIVER, ability)
  },
  setAbilityEditDriver({ commit }, ability) {
    commit(SET_ABILITY_EDIT_DRIVER, ability)
  },
  setAbilityDriverService({ commit }, ability) {
    commit(SET_ABILITY_DRIVER_SERVICE, ability)
  },
  setAbilityDriverMonitor({ commit }, ability) {
    commit(SET_ABILITY_DRIVER_MONITOR, ability)
  },
  setAbilityDriverTrajectory({ commit }, ability) {
    commit(SET_ABILITY_DRIVER_TRAJECTORY, ability)
  },
  setAbilityDriverMessage({ commit }, ability) {
    commit(SET_ABILITY_DRIVER_MESSAGE, ability)
  },
  setAbilityTransaction({ commit }, ability) {
    commit(SET_ABILITY_TRANSACTION, ability)
  },
  setAbilityTransactionStatistics({ commit }, ability) {
    commit(SET_ABILITY_TRANSACTION_STATISTICS, ability)
  },
  setAbilityCustomer({ commit }, ability) {
    commit(SET_ABILITY_CUSTOMER, ability)
  },
  setAbilityStore({ commit }, ability) {
    commit(SET_ABILITY_STORE, ability)
  },
  setAbilityLandmark({ commit }, ability) {
    commit(SET_ABILITY_LANDMARK, ability)
  },
  setAbilityReservation({ commit }, ability) {
    commit(SET_ABILITY_RESERVATION, ability)
  },
  setAbilityDispatchArea({ commit }, ability) {
    commit(SET_ABILITY_DISPATCH_AREA, ability)
  },
  setAbilityScheduledArea({ commit }, ability) {
    commit(SET_ABILITY_SCHEDULED_AREA, ability)
  },
  setAbilityScheduledBoard({ commit }, ability) {
    commit(SET_ABILITY_SCHEDULED_BOARD, ability)
  },
  setAbilityMobilePayment({ commit }, ability) {
    commit(SET_ABILITY_MOBILE_PAYMENT, ability)
  },
  setAbilityUserManagement({ commit }, ability) {
    commit(SET_ABILITY_USER_MANAGEMENT, ability)
  },
  setAbilityUserBehavior({ commit }, ability) {
    commit(SET_ABILITY_USER_BEHAVIOR, ability)
  },
  setAbilityPositionManagement({ commit }, ability) {
    commit(SET_ABILITY_POSITION_MANAGEMENT, ability)
  },
  setAbilityTransactionRecord({ commit }, ability) {
    commit(SET_ABILITY_TRANSACTION_RECORD, ability)
  },
  setAbilityCallCar({ commit }, ability) {
    commit(SET_ABILITY_CALL_CAR, ability)
  },
  setAbilitySaveHailBill({ commit }, ability) {
    commit(SET_ABILITY_SAVE_HAIL_BILL, ability)
  },
  setAbilitySaveReservation({ commit }, ability) {
    commit(SET_ABILITY_SAVE_RESERVATION, ability)
  },
  setAbilityAnnouncement({ commit }, ability) {
    commit(SET_ABILITY_ANNOUNCEMENT, ability)
  },
  setAbilityUserDeletion({ commit }, ability) {
    commit(SET_ABILITY_USER_DELETION, ability)
  },
}



// WEBPACK FOOTER //
// ./src/store/positionStore/actions.js